import { AwardedFieldsDto, BseDto, BseStatusDto, PublishedFieldsDto } from "../../autogen/bff-api";

export const requirePublishedOrAwardedState = (bse: BseDto): PublishedFieldsDto | AwardedFieldsDto => {
  switch (bse.status) {
    case BseStatusDto.Awarded: {
      const fields = bse.awardedFields;
      if (!fields) {
        throw Error("Status is awarded, but no awarded fields found.");
      }
      return fields;
    }
    case BseStatusDto.Draft:
      throw Error("cannot require deadline for drafts");
    case BseStatusDto.Completed:
    case BseStatusDto.DeadlineHasPassed:
    case BseStatusDto.Cancelled:
    case BseStatusDto.Closed:
    case BseStatusDto.Published: {
      const fields = bse.publishedFields;
      if (!fields) {
        throw Error("No published fields");
      }
      return fields;
    }
  }
};
